// Homepage banner toggle
// jQuery(document).ready(function () {
//   jQuery(".home-banner-btn-1").on("click", function (event) {
//     event.preventDefault();
//     jQuery(".home-banner-video-1").toggle();
//   });
// })

jQuery(document).ready(function () {
  if (document.location.pathname == "/pages/ritual") {
    const video = document.getElementById("hpqrcode");
    video.addEventListener("click", function () {
      if (video.paused || video.ended) {
        video.play();
        // video.setAttribute("controls", true); // Show controls only after play
      } else {
        video.pause();
      }
    });
  }
});

// document.addEventListener("DOMContentLoaded", function () {
//   setTimeout(function () {
//     const firstPosterButton = document.querySelector(".deferred-media__poster");
//     if (firstPosterButton) {
//       firstPosterButton.click();
//     }
//   }, 100);
// });

// Testimonial Slider
jQuery(document).ready(function () {
  if (document.location.pathname == "/") {
    jQuery(".testimonials-owlCarousel").owlCarousel({
      loop: false,
      touchDrag: false,
      mouseDrag: false,
      pullDrag: false,
      margin: 10,
      nav: false,
      autoplay: false,
      responsive: {
        0: {
          items: 1,
          touchDrag: true,
        },
        600: {
          items: 1,
          touchDrag: true,
        },
        1000: {
          items: 1,
        },
      },
    });
  }
  // if (
  //   document.location.pathname == "/products/nootropic-blend-starter-kit" ||
  //   document.location.pathname == "/products/superfood-creamer-w-coffee" ||
  //   document.location.pathname == "/products/superfood-matcha-latte" ||
  //   document.location.pathname == "/products/smart-creamer-trinity-pack"
  // ) {
  //   function isInViewport(element) {
  //     let rect = element.getBoundingClientRect();
  //     return (
  //       rect.top >= 0 &&
  //       rect.left >= 0 &&
  //       rect.bottom <=
  //         (window.innerHeight || document.documentElement.clientHeight) &&
  //       rect.right <=
  //         (window.innerWidth || document.documentElement.clientWidth)
  //     );
  //   }

  //   let $carousel = jQuery(".testimonials-owlCarousel"); // Assuming you're using jQuery and the carousel is initialized with the class .owl-carousel

  //   $carousel.owlCarousel({
  //     loop: true,
  //     touchDrag: true,
  //     mouseDrag: true,
  //     pullDrag: false,
  //     margin: 10,
  //     nav: false,
  //     autoplay: true,
  //     autoplayTimeout: 5000,
  //     // // slideTransition: "ease-in",
  //     // animateOut: "animate__slow 2s",
  //     animateIn: "animate__slow 1s",
  //     responsive: {
  //       0: {
  //         items: 1,
  //       },
  //       600: {
  //         items: 1,
  //       },
  //       1000: {
  //         items: 1,
  //       },
  //     },
  //   });
  //   window.onscroll = () => {
  //     // Check on page load if the carousel is in the viewport
  //     if (isInViewport($carousel[0])) {
  //       $carousel.trigger("play.owl.autoplay");
  //     }
  //   };
  // }

  if (document.location.pathname == "/pages/take-quiz") {
    jQuery(".testimonials-owlCarousel").owlCarousel({
      loop: false,
      touchDrag: false,
      mouseDrag: false,
      pullDrag: false,
      margin: 10,
      nav: false,
      autoplay: false,
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 1,
        },
        1000: {
          items: 1,
        },
      },
    });
  }
});

// Fetured Products Slider
jQuery(document).ready(function () {
  if (document.location.pathname == "/") {
    jQuery(".featured-products-owl-carousel").owlCarousel({
      loop: false,
      margin: 30,
      nav: false,
      autoplay: false,
      autoWidth: false,
      responsive: {
        0: {
          items: 1.5,
          center: true,
          margin: 25,
          mergeFit: true,
          merge: true,
        },
        600: {
          items: 1.5,
          center: false,
          margin: 25,
        },
        1000: {
          items: 4,
        },
      },
    });
  }

  if (document.location.pathname == "/pages/take-quiz") {
    jQuery(".featured-products-owl-carousel").owlCarousel({
      loop: false,
      margin: 30,
      nav: false,
      autoplay: false,
      autoWidth: false,
      responsive: {
        0: {
          items: 1.5,
          center: true,
          margin: 25,
          mergeFit: true,
          merge: true,
        },
        600: {
          items: 1.5,
          center: false,
          margin: 25,
        },
        1000: {
          items: 4,
        },
      },
    });
  }
});

// Master Class Slider
jQuery(document).ready(function () {
  if (document.location.pathname == "/pages/masterclass") {
    jQuery(".masterclass-owl-carousel").owlCarousel({
      loop: false,
      margin: 95,
      nav: false,
      autoplay: false,
      autoWidth: false,
      responsive: {
        0: {
          items: 1.5,
          center: true,
          margin: 25,
        },
        600: {
          items: 1.5,
          center: false,
          margin: 25,
        },
        1000: {
          items: 3,
        },
      },
    });
  }
});

// Morning Ritual Slider
jQuery(document).ready(function () {
  // if (document.location.pathname == "/products/smart-creamer") {}
  jQuery(".morning-ritual").owlCarousel({
    loop: false,
    margin: 82,
    nav: false,
    autoplay: false,
    autoWidth: false,
    responsive: {
      0: {
        items: 1.5,
        center: true,
        margin: 22,
      },
      600: {
        items: 3,
        center: false,
        margin: 22,
      },
      1000: {
        items: 3,
      },
    },
  });
});

// Product Tab Content
jQuery(document).ready(function () {
  if (document.location.pathname == "/pages/shop") {
    var hasfval = document.location.hash.substring(1);
    //Hide the all tab
    //jQuery('.product-tabcontent').hide();
    //Show/hide tabs
    jQuery(".product-tablinks").on("click", function (evt) {
      //evt.preventDefault();
      var offset = jQuery(this).offset();
      offset.left -= 20;
      offset.top -= 20;
      //       jQuery('.product-tablinks.active').removeClass('active');
      //       jQuery(this).addClass('active');
      //       var tablinksindex = jQuery(this).index();
      //       jQuery('[id*="shopify-section-template--15552773062806__product-tab-"]').hide();
      //       jQuery("#shopify-section-template--15552773062806__product-tab-"+(tablinksindex+1)+" ").show();
      jQuery("html, body").animate({
        scrollTop: offset.top,
        scrollLeft: offset.left,
      });
      var tabval = jQuery(this).prop("hash");
      tabval = tabval.replace("#", "");
      if (tabval == "creamer") {
        jQuery(".product-tablinks.active").removeClass("active");
        jQuery(this).addClass("active");
        jQuery("#shopify-section-template--15552773062806__creamer-tab").show();
        jQuery("#shopify-section-template--15552773062806__creamer-box").show();
        jQuery("#shopify-section-template--15552773062806__coffee-tab").hide();
        jQuery("#shopify-section-template--15552773062806__coffee-box").hide();
        jQuery("#shopify-section-template--15552773062806__matcha-tab").hide();
        jQuery("#shopify-section-template--15552773062806__matcha-box").hide();
        jQuery("#shopify-section-template--15552773062806__variety-tab").hide();
        jQuery("#shopify-section-template--15552773062806__variety-box").hide();
      } else if (tabval == "coffee") {
        jQuery(".product-tablinks.active").removeClass("active");
        jQuery(this).addClass("active");
        jQuery("#shopify-section-template--15552773062806__creamer-tab").hide();
        jQuery("#shopify-section-template--15552773062806__creamer-box").hide();
        jQuery("#shopify-section-template--15552773062806__coffee-tab").show();
        jQuery("#shopify-section-template--15552773062806__coffee-box").show();
        jQuery("#shopify-section-template--15552773062806__matcha-tab").hide();
        jQuery("#shopify-section-template--15552773062806__matcha-box").hide();
        jQuery("#shopify-section-template--15552773062806__variety-tab").hide();
        jQuery("#shopify-section-template--15552773062806__variety-box").hide();
      } else if (tabval == "matcha") {
        jQuery(".product-tablinks.active").removeClass("active");
        jQuery(this).addClass("active");
        jQuery("#shopify-section-template--15552773062806__creamer-tab").hide();
        jQuery("#shopify-section-template--15552773062806__creamer-box").hide();
        jQuery("#shopify-section-template--15552773062806__coffee-tab").hide();
        jQuery("#shopify-section-template--15552773062806__coffee-box").hide();
        jQuery("#shopify-section-template--15552773062806__matcha-tab").show();
        jQuery("#shopify-section-template--15552773062806__matcha-box").show();
        jQuery("#shopify-section-template--15552773062806__variety-tab").hide();
        jQuery("#shopify-section-template--15552773062806__variety-box").hide();
      } else if (tabval == "variety-pack") {
        jQuery(".product-tablinks.active").removeClass("active");
        jQuery(this).addClass("active");
        jQuery("#shopify-section-template--15552773062806__creamer-tab").hide();
        jQuery("#shopify-section-template--15552773062806__creamer-box").hide();
        jQuery("#shopify-section-template--15552773062806__coffee-tab").hide();
        jQuery("#shopify-section-template--15552773062806__coffee-box").hide();
        jQuery("#shopify-section-template--15552773062806__matcha-tab").hide();
        jQuery("#shopify-section-template--15552773062806__matcha-box").hide();
        jQuery("#shopify-section-template--15552773062806__variety-tab").show();
        jQuery("#shopify-section-template--15552773062806__variety-box").show();
      } else {
        jQuery(".product-tablinks.active").removeClass("active");
        jQuery(this).addClass("active");
        jQuery("#shopify-section-template--15552773062806__creamer-tab").hide();
        jQuery("#shopify-section-template--15552773062806__creamer-box").hide();
        jQuery("#shopify-section-template--15552773062806__coffee-tab").hide();
        jQuery("#shopify-section-template--15552773062806__coffee-box").hide();
        jQuery("#shopify-section-template--15552773062806__matcha-tab").hide();
        jQuery("#shopify-section-template--15552773062806__matcha-box").hide();
        jQuery("#shopify-section-template--15552773062806__variety-tab").hide();
        jQuery("#shopify-section-template--15552773062806__variety-box").hide();
      }
    });
    //open tab from the url
    if (hasfval) {
      document.getElementById(hasfval).click();
      document.getElementById(hasfval).scrollIntoView();
    } else {
      document.getElementById("creamer").click();
    }
  }
});

// Legal Tab Content
jQuery(document).ready(function () {
  if (document.location.pathname == "/pages/legal") {
    //Hide the all tab
    jQuery(".legal-tabcontent").hide();
    //Show/hide tabs
    jQuery(".legal-tablinks").on("click", function () {
      jQuery(".legal-tablinks.active").removeClass("active");
      jQuery(this).addClass("active");
      var tablinksindex = jQuery(this).index();
      jQuery(".legal-tabcontent").hide();
      jQuery(".legal-tabcontent").eq(tablinksindex).show();
    });
    jQuery(".legal-plink").on("click", function () {
      var haslpval;
      haslpval = jQuery(this).prop("hash");
      haslpval = haslpval.replace("#", "");
      jQuery("#" + haslpval).trigger("click");
      document.getElementById(haslpval).scrollIntoView();
    });
  }

  //Open the tab to click footer link
  jQuery(
    ".footer .footer__blocks-wrapper .footer-block:nth-child(2) .footer-block__details-content li a"
  ).on("click", function (evt) {
    //evt.preventDefault();
    if (document.location.pathname == "/pages/legal") {
      var haslval;
      haslval = jQuery(this).prop("hash");
      haslval = haslval.replace("#", "");
      jQuery("#" + haslval).trigger("click");
      document.getElementById(haslval).scrollIntoView();
    } else {
      var haslval;
      haslval = document.location.origin + jQuery(this).attr("href");
      document.location.href = haslval;
    }
  });
  //open tab from the url
  if (document.location.pathname == "/pages/legal") {
    var hasfval = document.location.hash.substring(1);
    if (hasfval) {
      document.getElementById(hasfval).click();
    } else {
      document.getElementById("terms-of-service").click();
    }
  }
});

// Change tab on browser back and forward button

window.onpopstate = function (event) {
  // For Legal Page
  if (document.location.pathname == "/pages/legal") {
    var hasfval = document.location.hash.substring(1);
    if (hasfval) {
      document.getElementById(hasfval).click();
    } else {
      document.getElementById("terms-of-service").click();
    }
  }
  // For Shop Page
  if (document.location.pathname == "/pages/shop") {
    var hasfval = document.location.hash.substring(1);
    if (hasfval) {
      document.getElementById(hasfval).click();
    } else {
      document.getElementById("creamer").click();
    }
  }
};

//Footer Logo
jQuery(document).ready(function () {
  var footerlogo = jQuery(".footer__logo").html();
  jQuery(".footer__logo").remove();
  jQuery(".footer-block:first").append(footerlogo);
});

jQuery("#rc_link_container a").click(function () {
  sessionStorage.removeItem("selected_parent");
  sessionStorage.setItem("selected_parent", parseInt(0));
});

//Landing page header, footer hide
// jQuery(document).ready(function () {
//   if (document.location.pathname == "/pages/masterclass") {
//     jQuery("#shopify-section-header").hide();
//     jQuery("#shopify-section-footer").hide();
//   }
// });

// Social link open in new tab
jQuery(document).on("click", ".list-social__link", function (e) {
  e.preventDefault();
  var url = jQuery(this).attr("href");
  window.open(url, "_blank");
});

// Homepage banner section
jQuery(document).ready(function () {
  jQuery(".youtube-link").grtyoutube({ theme: "light", autoPlay: true });
});

// Product page active class
jQuery(document).ready(function () {
  jQuery(".product-tab a")
    .filter(function () {
      //return this.href === location.href;
      return this.href === location.origin + location.pathname;
    })
    .addClass("active");
});

// Product page video section

// jQuery(document).ready(function () {
//   var ctrlVideo = document.getElementById("breakfast-video");
//   mousedown = false;

//   jQuery("#breakfast-video").removeAttr("controls");
//   jQuery("#breakfast-video-btn").click(function () {
//     if (jQuery("#breakfast-video-btn").hasClass("active")) {
//       ctrlVideo.play();
//       jQuery("#breakfast-video-btn").hide();
//       jQuery("#breakfast-video").attr("controls", "");
//       jQuery("#breakfast-video-btn").toggleClass("active");
//     } else {
//       ctrlVideo.pause();
//       jQuery("#breakfast-video-btn").show();
//       jQuery("#breakfast-video-btn").toggleClass("active");
//     }
//   });

//   ctrlVideo.click(function () {
//     if (this.paused) {
//       this.play();
//       return false;
//     }
//     return true;
//   });

//   ctrlVideo.mousedown(function () {
//     mousedown = true;
//   });

//   jQuery(window).mouseup(function () {
//     mousedown = false;
//   });

//   ctrlVideo.on("play", function () {
//     ctrlVideo.attr("controls", "");
//   });

//   ctrlVideo.on("pause", function () {
//     if (!mousedown) {
//       ctrlVideo.removeAttr("controls");
//     }
//   });
// });

// Add link to image on section

jQuery(document).ready(function () {
  jQuery(
    ".section-template--15391833817238__4744cf2e-dfa7-4cff-9cbd-6446653863f2-padding img"
  ).wrap(jQuery("<a>").attr("href", "/products/smart-creamer-trinity-pack"));
});

// jQuery(".section-1-btn-v2").click(function (e) {
//   e.preventDefault();
//   var element = document.getElementById(
//     "ProductInfo-template--15922265260182__main"
//   );
//   element.scrollIntoView();
// });

// Subscriptions widget

// jQuery(document).ready(function () {
//   var inter = 5000;
//   myInterval = setInterval(function () {
//     if (
//       typeof jQuery(document).find(".rc_widget__option--subsave") !=
//         "undefined" &&
//       typeof jQuery(document).find(".subscriptiondescription").html() ==
//         "undefined"
//     ) {
//       var currentprice = jQuery(document)
//         .find(".rc_widget__option--subsave")
//         .find('[aria-label="recurring price"]')
//         .html();
//       var oldprice = jQuery(document)
//         .find(".rc_widget__option--onetime")
//         .find('[aria-label="original price"]')
//         .html();
//       var newprice =
//         currentprice +
//         '<span class="strickmarkprice"><strike>' +
//         oldprice +
//         "</strike></span>";
//       jQuery(document)
//         .find(".rc_widget__option--subsave")
//         .find('[aria-label="recurring price"]')
//         .html(newprice);
//       jQuery(document)
//         .find(".rc_widget__option--subsave")
//         .append(
//           '<ul class="subscriptiondescription"><li><strong>30 servings</strong> (3 tubes) shipped monthly, pause or cancel anytime</li><li><strong>First order</strong> comes with <strong>FREE frother</strong> and <strong>tube key</strong></li></ul>'
//         );
//       jQuery(document)
//         .find(".rc_widget__option--onetime")
//         .append(
//           '<ul class="subscriptiononetimedescription"><li><strong>30 servings</strong> (3 tubes) shipped once</li><li>Comes with <strong>FREE frother</strong> and <strong>tube key</strong></li></ul>'
//         );
//       clearInterval(myInterval);
//       //inter = 5000;
//     }
//   }, inter);
// });

jQuery(document).ready(function () {
  jQuery(".owl-carousel .owl-stage-outer .owl-stage").css(
    "transform",
    "translate3d(0px, 0px, 0px)"
  );
});

//Loox Rating - Extra Space
// jQuery(document).ready(function () {
//   var _rating_str = jQuery(".loox-rating-label").html();
//   if (_rating_str) {
//     _rating_str = _rating_str.replace("&nbsp;", "");
//   }
//   jQuery(".loox-rating-label").html(_rating_str);
// });

// Add body class for Recharge pages (header style toggle)
if (window.location.pathname.includes("/tools/recurring/")) {
  document.body.classList.add("recharge-page");
}

// Login/Logout - Rechargeapps Subscriptions
jQuery(document).ready(function () {
  var searchParams = new URLSearchParams(location.search);
  var usrLoginToken = searchParams.get("token");

  if (usrLoginToken && !location.pathname.includes("/logout")) {
    setLoginCookieForUsr("usr_login", true);
    setLoginCookieForUsr("usr_login_token", usrLoginToken);

    // Try to get urlKey from search params first, then from pathname
    var usrLoginUrlkey = searchParams.get("url_key") || searchParams.get("urlkey");
    if (!usrLoginUrlkey) {
      var pathSegments = location.pathname.split("/");
      usrLoginUrlkey = pathSegments[pathSegments.length - 2];
    }
    if (usrLoginUrlkey) {
      setLoginCookieForUsr("usr_login_urlkey", usrLoginUrlkey);
    }
  }
});

// if (jQuery(window).width() < 767) {
//   jQuery(window).scroll(function () {
//     if (jQuery(window).scrollTop() >= 1300) {
//       jQuery(
//         ".product-productv2 #product-form-template--16064753762454__main > div"
//       ).attr(
//         "style",
//         "position:fixed;bottom:15px;left:15px;width:calc(100% - 30px);"
//       );
//     } else {
//       jQuery(
//         ".product-productv2 #product-form-template--16064753762454__main > div"
//       ).attr("style", "position:relative;");
//     }
//   });
// }

// if (
//   /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
//     navigator.userAgent
//   )
// ) {
// true for mobile device
// jQuery(window).scroll(function () {
// if (jQuery(window).scrollTop() >= 1024) {
//   jQuery(
//     ".product-productv2 #product-form-template--16064753762454__main > div"
//   ).attr(
//     "style",
//     "position:fixed;bottom:15px;left:15px;width:calc(100% - 30px);"
//   );
// } else {
//   jQuery(
//     ".product-productv2 #product-form-template--16064753762454__main > div"
//   ).attr("style", "position:relative;");
// }
// if (jQuery(window).scrollTop() >= 480) {
//   jQuery(
//     ".product-productv3 #product-form-template--16080735436950__main > div"
//   ).attr(
//     "style",
//     "position:fixed;bottom:15px;left:15px;width:calc(100% - 30px);"
//   );
// } else {
//   jQuery(
//     ".product-productv3 #product-form-template--16080735436950__main > div"
//   ).attr("style", "position:relative;");
// }
// if (jQuery(window).scrollTop() >= 480) {
//   jQuery(
//     "#product-section-single-tube .buy_buttons-wrap .product-form .product-form__submit"
//   ).attr(
//     "style",
//     "position:fixed;bottom:15px;left:15px;width:100%;max-width:210px;"
//   );
//   jQuery(
//     "#product-section-single-tube.product-section-rb-starterkitprov2 .buy_buttons-wrap .product-form .product-form__submit"
//   ).attr(
//     "style",
//     "position:fixed;bottom:15px;left:15px;width:100%;max-width:calc(100% - 30px) !important;"
//   );
//   jQuery(
//     "#product-section-single-tube .buy_buttons-wrap .product-form .product-form__quantity"
//   ).attr(
//     "style",
//     "position:fixed;bottom:15px;right:14px;width:100%;max-width:calc(100% - 240px);"
//   );
// } else {
//   jQuery(
//     "#product-section-single-tube .buy_buttons-wrap .product-form .product-form__submit"
//   ).attr("style", "position:relative;");
//   jQuery(
//     "#product-section-single-tube .buy_buttons-wrap .product-form .product-form__quantity"
//   ).attr("style", "position:relative;");
// }
// if (jQuery(window).scrollTop() >= 480) {
//   jQuery("#mh-featured-product .form > .product-form__buttons").attr(
//     "style",
//     "position:fixed;bottom:15px;left:15px;width:calc(100% - 30px);"
//   );
// } else {
//   jQuery("#mh-featured-product .form > .product-form__buttons").attr(
//     "style",
//     "position:relative;"
//   );
// }
// if (jQuery(window).scrollTop() >= 768) {
//   jQuery(".page-homepage-v2 .home-banner-section .home-banner-btn-2").attr(
//     "style",
//     "position:fixed;bottom:15px;left:15px;width:calc(100% - 30px);"
//   );
// } else {
//   jQuery(".page-homepage-v2 .home-banner-section .home-banner-btn-2").attr(
//     "style",
//     "position:relative;"
//   );
// }
//   });
// }

// jQuery(window).scroll(function () {
//   if (jQuery(window).scrollTop() > 0) {
//     jQuery("#shopify-section-header-v2 .header-v2 header").addClass(
//       "sticky-header"
//     );
//   } else {
//     jQuery("#shopify-section-header-v2 .header-v2 header").removeClass(
//       "sticky-header"
//     );
//   }
// });

//);

//} else {
// false for not mobile device
//document.write("not mobile device");
//}

// const formDiv = document.getElementById("product-form-installment");

// formDiv.addEventListener("load", function () {
//   console.log("Div has finished loading!");
// });

//jQuery("product-form").hide();

jQuery(document).ready(function () {
  const productDiv = new Event("ReChargeWidget-loaded");
  if (window.dispatchEvent(productDiv)) {
    //console.log("Div product-form-installment has finished loading!");
    jQuery("product-form").show();
  }
});

function isElementInViewport(element) {
  let rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

let $carouselv3 = jQuery(".testimonials-owlCarousel-pv3");
$carouselv3.owlCarousel({
  loop: false,
  touchDrag: false,
  mouseDrag: false,
  pullDrag: false,
  margin: 10,
  nav: false,
  autoplay: false,
  responsive: {
    0: {
      /*items: 1,
      loop: true,
      nav: true,
      autoplay: true,
      autoplayTimeout: 3000 ,
      touchDrag: true,
      margin: 10,     
      startPosition: 0*/
      items: 1,
      loop: false,
      autoplay: false,
      touchDrag: true,
      autoplayTimeout: 3000, // Change the autoplay speed in milliseconds
      autoplayHoverPause: true,
    },
    600: {
      items: 4,
    },
    1000: {
      items: 4,
    },
  },
});

window.onscroll = () => {
  if ($carouselv3[0]) {
    // Check on page load if the carousel is in the viewport
    if (isElementInViewport($carouselv3[0])) {
      $carouselv3.trigger("play.owl.autoplay");
    }
  }
};

jQuery(document).ready(function () {
  // if (document.location.pathname == "/products/smart-creamer") {}
  jQuery(".morning-ritual-pv3").owlCarousel({
    loop: false,
    touchDrag: false,
    mouseDrag: false,
    pullDrag: false,
    margin: 0,
    nav: false,
    autoplay: false,
    autoWidth: false,
    responsive: {
      0: {
        loop: false,
        items: 1,
        center: false,
        touchDrag: true,
        autoplay: false,
      },
      600: {
        items: 3,
      },
      1000: {
        items: 3,
      },
    },
  });
});
const el = document.getElementById("read-more-link");
if (el) {
  el.addEventListener("click", function () {
    var elementsaddeds = document.querySelectorAll(
      "body.page-homepage-v2 .collapsible-content-wrapper-narrow .grid__item div.accordion"
    );
    elementsaddeds.forEach((elementcartss) => {
      elementcartss.setAttribute("style", "display:block");
    });
    this.style.display = "none";
  });
}

/*
window.addEventListener("scroll", () => {
  const container = document.querySelector("#video-banner");
  const playVideo = document.getElementById("video-mh");
  if (container) {
    let containerBounding = container.getBoundingClientRect().top;
    //let scrollPosition = window.scrollY;
    console.log(containerBounding);
    if (containerBounding <= 0) {     
      playVideo.play();
    } else {
      playVideo.pause();
    }
  }
});
*/

document.addEventListener("DOMContentLoaded", function () {
  // Replace 'your-product-id' with the actual product ID you want to add to the cart
  // Function to add a product to the cart
  function addProductToCart(productID) {
    const data = {
      items: [
        {
          id: productID,
          quantity: 1, // You can change the quantity if needed
        },
      ],
    };

    fetch("/cart/add.js?", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        // Check if the product was added to the cart successfully
        if (data.status === "added") {
          // Product added successfully
          window.location.href = "/checkout";
          console.log("Product added to the cart.");
          // You can optionally redirect to the cart page or perform other actions.
        } else {
          // Product was not added to the cart
          window.location.href = "/checkout";
          console.error("Failed to add the product to the cart.");
        }
      })
      .catch((error) => {
        console.error(
          "An error occurred while adding the product to the cart.",
          error
        );
      });
  }

  // Event listener for a button click to add the product
  const addButton = document.getElementById("addToCartButtonmh"); // Replace with your button's ID
  if (addButton) {
    addButton.addEventListener("click", () => {
      var productId = addButton.getAttribute("data-product-id");
      if (productId) {
        document.cookie = "discount_code=MARK10; path=/;";
      }
      addProductToCart(productId);
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  let testimonials = document.getElementById("testimonials-link");
  if (testimonials) {
    testimonials.addEventListener("click", function (e) {
      e.preventDefault();
      //let hashID = document.location.hash;
      var element = document.getElementById("looxReviews");
      var headerOffset = 150;
      var elementPosition = element.getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    });
  }
});

function setLoginCookieForUsr(nameofcookie, valueofcookie) {
  var cookieValue = encodeURIComponent(valueofcookie);
  var expires = "; expires=Fri, 31 Dec 9999 23:59:59 GMT"; // Far future expiration date
  document.cookie = nameofcookie + "=" + cookieValue + expires + "; path=/";
}

document.addEventListener("DOMContentLoaded", function () {
  function retrieveCookieValue(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  }
  setTimeout(() => {
    const usrLogin = retrieveCookieValue("usr_login");
    const usrLoginToken = retrieveCookieValue("usr_login_token");
    const usrLoginUrlKey = retrieveCookieValue("usr_login_urlkey");

    if (usrLogin === "true" && usrLoginToken && usrLoginUrlKey) {
      const menuDrawer = document.getElementById("menu-drawer");
      const nav = menuDrawer.querySelector("nav.menu-drawer__navigation");
      const menu = nav.querySelector("ul.menu-drawer__menu.list-menu");
      const lastLi = menu.querySelector("li:last-child");
      const loginLink = lastLi ? lastLi.querySelector('a[href*="/tools/recurring/login"], a[href*="/account/login"]') : null;

      // Remove the last login item if it exists
      if (loginLink) {
        lastLi.remove();
      }

      // Check if the custom menu items are already added
      if (
        !menu.querySelector('a[href*="overview"]') &&
        !menu.querySelector('a[href*="logout"]')
      ) {
        // Append "My Account" and "Logout" items
        const myAccountLi = document.createElement("li");
        const logoutLi = document.createElement("li");

        myAccountLi.innerHTML = `<a class="menu-drawer__menu-item list-menu__item link link--text focus-inset menu-drawer__account" href="/tools/recurring/portal/${usrLoginUrlKey}/overview?token=${usrLoginToken}">my account</a>`;
        logoutLi.innerHTML = `<a class="menu-drawer__menu-item list-menu__item link link--text focus-inset menu-drawer__account" href="/tools/recurring/portal/${usrLoginUrlKey}/logout?token=${usrLoginToken}">logout</a>`;

        menu.appendChild(myAccountLi);
        menu.appendChild(logoutLi);
      }

      // Update desktop header account link
      const desktopAccountLink = document.getElementById("desktop-account-link");
      if (desktopAccountLink) {
        desktopAccountLink.href = `/tools/recurring/portal/${usrLoginUrlKey}/overview?token=${usrLoginToken}`;
        desktopAccountLink.setAttribute("title", "my account");
      }

      // Add desktop logout link next to account icon
      const headerIcons = document.querySelector(".header__icons");
      if (headerIcons && !headerIcons.querySelector(".desktop-logout-link")) {
        const logoutLink = document.createElement("a");
        logoutLink.href = `/tools/recurring/portal/${usrLoginUrlKey}/logout?token=${usrLoginToken}`;
        logoutLink.className = "desktop-logout-link header__icon link focus-inset small-hide";
        logoutLink.textContent = "logout";
        logoutLink.style.cssText = "font-size:12px;text-transform:uppercase;letter-spacing:.1em;text-decoration:none;";
        headerIcons.insertBefore(logoutLink, headerIcons.querySelector("#cart-icon-bubble"));
      }
    }
  }, 500);
});

// Intercept logout clicks — delete cookies, ping Recharge in background, go home
document.addEventListener("click", function (e) {
  var target = e.target.closest('a[href*="logout"]');
  if (!target) return;
  var href = target.getAttribute("href");
  if (!href || !href.includes("token=")) return;
  e.preventDefault();
  e.stopPropagation();
  document.cookie = "usr_login=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;";
  document.cookie = "usr_login_token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;";
  document.cookie = "usr_login_urlkey=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;";
  // Ping Recharge logout in background (survives page navigation)
  new Image().src = href;
  // Redirect straight home — don't navigate to Recharge URL (causes blank page)
  window.location.href = "/";
}, true);

document.addEventListener("DOMContentLoaded", function () {
  function retrieveCookieValueD(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  }

  function deleteCookieD(ckkoiname) {
    document.cookie =
      ckkoiname + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;";
  }

  const usrLogin = retrieveCookieValueD("usr_login");
  const usrLoginToken = retrieveCookieValueD("usr_login_token");
  const usrLoginUrlKey = retrieveCookieValueD("usr_login_urlkey");

  if (usrLogin === "true" && usrLoginToken && usrLoginUrlKey) {
    const currentPath = window.location.pathname;
    const currentSearch = window.location.search;
    const expectedPath = `/tools/recurring/portal/${usrLoginUrlKey}/logout`;

    if (currentPath === expectedPath && currentSearch.includes(`token=${usrLoginToken}`)) {
      // Delete the cookies
      deleteCookieD("usr_login");
      deleteCookieD("usr_login_token");
      deleteCookieD("usr_login_urlkey");

      // Redirect to the home page
      window.location.href = "/";
    }
  }
});

// // Get the specific slide by its ID.
// const targetSlide = document.getElementById("Slide-template--17885898932374__main-29792498745494");

// if (!targetSlide) {
//   console.error("Target slide not found");
// } else {
//   console.log("Target slide found:", targetSlide);
// }

// // Set up the IntersectionObserver options.
// // Here, root is null (viewport) and threshold is 0.5 (50% visibility).
// const observerOptions = {
//   root: null,
//   threshold: 0.5
// };

// // Create the IntersectionObserver.
// const observer = new IntersectionObserver((entries, observer) => {
//   entries.forEach(entry => {
//     console.log("IntersectionObserver entry:", entry);
//     if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
//       console.log("Target slide is in viewport");

//       // Look for the deferred-media element inside the target slide.
//       const deferredMedia = targetSlide.querySelector("deferred-media");
//       if (deferredMedia) {
//         let video = deferredMedia.querySelector("video");
//         if (!video) {
//           console.log("Video not loaded in deferred-media; simulating click on thumbnail button.");
//           // Get the data-media-id from the target slide.
//           const dataMediaId = targetSlide.getAttribute("data-media-id");
//           // Find the thumbnail li that corresponds to this target slide.
//           const thumbLi = document.querySelector(`li[data-target="${dataMediaId}"]`);
//           if (thumbLi) {
//             // Inside the thumbnail li, find the button with the video.
//             const videoPlayButton = thumbLi.querySelector("button.thumbnail.video");
//             if (videoPlayButton) {
//               console.log("Found video play button in thumbnail li; dispatching click event.");
//               // Dispatch a mouse click event.
//               const clickEvent = new MouseEvent("click", {
//                 bubbles: true,
//                 cancelable: true,
//                 view: window
//               });
//               videoPlayButton.dispatchEvent(clickEvent);
//               // Wait for the deferred-media component to load the video element.
//               setTimeout(() => {
//                 video = deferredMedia.querySelector("video");
//                 if (video) {
//                   console.log("Video element loaded after thumbnail button click:", video);
//                   video.muted = true; // ensure muted for autoplay
//                   video.play()
//                     .then(() => console.log("Video autoplay started successfully after thumbnail click."))
//                     .catch(err => console.error("Error playing video:", err));
//                 } else {
//                   console.error("Video still not loaded after clicking thumbnail button.");
//                 }
//               }, 1000); // increased delay to allow for loading
//             } else {
//               console.error("Video play button not found in thumbnail li.");
//             }
//           } else {
//             console.error("Thumbnail li for target slide not found.");
//           }
//         } else {
//           console.log("Video element already loaded; attempting autoplay.");
//           video.muted = true;
//           video.play()
//             .then(() => console.log("Video autoplay started successfully."))
//             .catch(err => console.error("Error playing video:", err));
//         }
//       } else {
//         console.error("Deferred-media element not found in target slide.");
//       }
//     } else {
//       console.log("Target slide is not sufficiently in viewport.");
//     }
//   });
// }, observerOptions);

// // Start observing the target slide.
// observer.observe(targetSlide);

// // List of product slide IDs
// const productSlideIds = [
//   "Slide-template--17885898932374__main-29792089604246",
//   "Slide-template--17885898932374__main-29792498745494",
//   "Slide-template--17885898932374__main-29791852134550",
//   "Slide-template--17885898932374__main-29792089505942",
//   "Slide-template--17885898932374__main-29792357220502",
//   "Slide-template--17885898932374__main-29784546541718",
//   "Slide-template--17123296215190__main-29791852134550",
//   "Slide-template--17084609396886__main-29791852134550",
//   "Slide-template--17123296215190__main-29792498745494",
//   "Slide-template--17084609396886__main-29792089604246",
//   "Slide-template--17123296215190__main-29792357220502",
//   "Slide-template--17084609396886__main-29792089505942",
//   "Slide-template--17123296215190__main-30451136331926",
//   "Slide-template--17885898932374__main-30448181870742",
//   "Slide-template--17885898932374__main-30451136331926",
//   "Slide-template--17123296215190__main-30448181870742",
//   "Slide-template--17123296215190__main-29791852134550",
//   "Slide-template--17123296215190__main-29784546541718",
//   "Slide-template--17123296215190__main-31180237832342",
//   "Slide-template--17123296215190__main-31180279971990",
//   "Slide-template--17123296215190__main-32203454578838",
//   "Slide-template--17123296215190__main-32203454546070",
//   "Slide-template--17885898932374__main-32203454578838",
//   "Slide-template--17885898932374__main-32203454546070",
//   "Slide-template--17123296215190__main-32203481710742",
//   "Slide-template--17123296215190__main-32203481743510",
//   "Slide-template--17885898932374__main-32203481710742",
//   "Slide-template--17885898932374__main-32203481743510"
// ];

// // IntersectionObserver options
// const observerOptions = {
//   root: null,
//   threshold: 0.5,
// };

// // Function to handle intersection changes
// const handleIntersection = (entries, observer) => {
//   entries.forEach((entry) => {
//     if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
//       console.log("Target slide is in viewport:", entry.target);

//       const deferredMedia = entry.target.querySelector("deferred-media");
//       if (deferredMedia) {
//         let video = deferredMedia.querySelector("video");
//         if (!video) {
//           console.log(
//             "Video not loaded; simulating click on thumbnail button."
//           );

//           const dataMediaId = entry.target.getAttribute("data-media-id");
//           const thumbLi = document.querySelector(
//             `li[data-target="${dataMediaId}"]`
//           );

//           if (thumbLi) {
//             const videoPlayButton = thumbLi.querySelector(
//               "button.thumbnail.video"
//             );
//             if (videoPlayButton) {
//               videoPlayButton.click(); // Simulate click on thumbnail button

//               setTimeout(() => {
//                 video = deferredMedia.querySelector("video");
//                 if (video) {
//                   console.log("Video loaded, starting autoplay.");
//                   video.muted = true;
//                   video
//                     .play()
//                     .catch((err) => console.error("Error playing video:", err));
//                 } else {
//                   console.error("Video still not found after click.");
//                 }
//               }, 1000);
//             } else {
//               console.error("Video play button not found.");
//             }
//           } else {
//             console.error("Thumbnail not found for media ID:", dataMediaId);
//           }
//         } else {
//           console.log("Video already loaded; starting autoplay.");
//           video.muted = true;
//           video
//             .play()
//             .catch((err) => console.error("Error playing video:", err));
//         }
//       } else {
//         console.error("Deferred-media element not found in slide.");
//       }
//     }
//   });
// };

// // Create observer
// const observer = new IntersectionObserver(handleIntersection, observerOptions);

// // Observe all product slides
// productSlideIds.forEach((slideId) => {
//   const slideElement = document.getElementById(slideId);
//   if (slideElement) {
//     observer.observe(slideElement);
//     console.log("Observing slide:", slideId);
//   } else {
//     // console.error("Slide not found:", slideId);
//   }
// });

// if (
//   /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
//     navigator.userAgent
//   )
// ) {
//   // true for mobile device

//   jQuery(window).scroll(function () {
//     if (jQuery(window).scrollTop() >= 780) {
//       jQuery(
//         "#product-section-single-tube.product-section-rb-starterkitprov2 .buy_buttons-wrap .product-form .product-form__submit"
//       ).attr(
//         "style",
//         "position:fixed;bottom:15px;left:15px;width:100%;max-width:calc(100% - 30px) !important;"
//       );
//     } else {
//       jQuery(
//         "#product-section-single-tube.product-section-rb-starterkitprov2 .buy_buttons-wrap .product-form .product-form__submit"
//       ).attr("style", "position:relative;");
//     }
//   });

//   // jQuery(window).on("scroll resize touchmove", function () {
//   //   var $button = jQuery(
//   //     "#product-section-single-tube.product-section-rb-starterkitprov2 .buy_buttons-wrap .product-form .product-form__submit"
//   //   );

//   //   // Get the current bounding rectangle of the button.
//   //   var rect = $button[0].getBoundingClientRect();

//   //   // Log the vertical positions to the console.
//   //   console.log("Button Top:", rect.top, "Button Bottom:", rect.bottom);
//   //   // true for mobile device
//   //   if (rect.top <= 0) {
//   //     jQuery(
//   //       "#product-section-single-tube.product-section-rb-starterkitprov2 .buy_buttons-wrap .product-form .product-form__submit"
//   //     ).attr(
//   //       "style",
//   //       "position:fixed;bottom:15px;left:15px;width:100%;max-width:calc(100% - 30px) !important;"
//   //     );
//   //   } else {
//   //     jQuery(
//   //       "#product-section-single-tube.product-section-rb-starterkitprov2 .buy_buttons-wrap .product-form .product-form__submit"
//   //     ).attr("style", "position:relative;");
//   //   }
//   // });
// }

const observerOptions = {
    root: null,
    threshold: 0.25,
};

const getProductSlideIds = () => {
    return Array.from(document.querySelectorAll('[id^="Slide-template--"][data-media-id]')).map(
        (slide) => slide.id
    );
};

const findDeferredMedia = (slide) => {
    return (
        slide.querySelector("deferred-media") ||
        slide.querySelector("shopify-deferred-media") ||
        slide.querySelector(".deferred-media")
    );
};

const advanceSliderOnVideoEnd = (video) => {
    if (video.dataset.autoplayNextAttached) return;
    video.dataset.autoplayNextAttached = "true";

    video.addEventListener(
        "ended",
        () => {
            const nextButton = document.querySelector(".slider-button--next");
            if (nextButton) {
                nextButton.click();
            } else {
                console.warn("Slider next button not found to advance after video end.");
            }
        },
        { once: true }
    );
};

const prepareVideoForSmoothPlay = (video) => {
    if (video.dataset.smoothPlayAttached) return;
    video.dataset.smoothPlayAttached = "true";
    video.style.opacity = "0";
    video.style.transition = "opacity 0.2s ease";

    const deferredMedia = video.closest("deferred-media, shopify-deferred-media, .deferred-media");

    const showVideo = () => {
        if (deferredMedia) {
            deferredMedia.style.background = "transparent";
            deferredMedia.style.backgroundColor = "transparent";
            deferredMedia.style.backgroundImage = "none";
        }
        video.style.opacity = "1";
        const poster = deferredMedia?.querySelector(".deferred-media__poster");
        if (poster) {
            poster.style.visibility = "hidden";
        }
    };

    video.addEventListener("playing", showVideo, { once: true });
    video.addEventListener("canplay", showVideo, { once: true });
};

const attemptPlayVideo = (video) => {
    if (!video) return Promise.reject(new Error("No video element."));
    video.muted = true;
    video.playsInline = true;
    video.setAttribute("playsinline", "");
    prepareVideoForSmoothPlay(video);
    advanceSliderOnVideoEnd(video);
    return video.play();
};

const waitForVideoElement = (deferredMedia, timeout = 4000) => {
    return new Promise((resolve, reject) => {
        const start = Date.now();
        const interval = setInterval(() => {
            const video = deferredMedia.querySelector("video");
            if (video) {
                clearInterval(interval);
                resolve(video);
                return;
            }
            if (Date.now() - start >= timeout) {
                clearInterval(interval);
                reject(new Error("Video not found after waiting."));
            }
        }, 150);
    });
};

const clickVideoThumbnail = (slide) => {
    const dataMediaId = slide.getAttribute("data-media-id");
    if (!dataMediaId) {
        console.error("Slide missing data-media-id.");
        return false;
    }

    const thumbLi = document.querySelector(`li[data-target="${dataMediaId}"]`);
    if (!thumbLi) {
        console.error("Thumbnail not found for media ID:", dataMediaId);
        return false;
    }

    const videoPlayButton = thumbLi.querySelector("button.thumbnail.video");
    if (!videoPlayButton) {
        console.error("Video play button not found for media ID:", dataMediaId);
        return false;
    }

    videoPlayButton.dispatchEvent(
        new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
        })
    );
    return true;
};

const handleIntersection = (entries) => {
    entries.forEach((entry) => {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.25) {
            return;
        }

        const slide = entry.target;
        console.log("Target slide is in viewport:", slide);

        const deferredMedia = findDeferredMedia(slide);
        if (!deferredMedia) {
            console.error("Deferred-media element not found in slide.");
            return;
        }

        const video = deferredMedia.querySelector("video");
        if (video) {
            console.log("Video already loaded; starting autoplay.");
            attemptPlayVideo(video).catch((err) =>
                console.error("Error playing video:", err)
            );
            return;
        }

        console.log("Video not loaded yet; trying to trigger thumbnail click.");
        const clicked = clickVideoThumbnail(slide);
        if (!clicked) {
            return;
        }

        waitForVideoElement(deferredMedia)
            .then((loadedVideo) => {
                console.log("Video loaded after click; starting autoplay.");
                return attemptPlayVideo(loadedVideo);
            })
            .catch((err) => {
                console.error("Unable to load video for autoplay:", err);
            });
    });
};

const observer = new IntersectionObserver(handleIntersection, observerOptions);

const observeSlides = () => {
    const slideIds = getProductSlideIds();
    if (slideIds.length === 0) {
        console.warn("No product slides found for autoplay observation.");
        return;
    }

    slideIds.forEach((slideId) => {
        const slideElement = document.getElementById(slideId);
        if (slideElement) {
            observer.observe(slideElement);
            console.log("Observing slide:", slideId);
        } else {
            console.warn("Slide not found:", slideId);
        }
    });
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeSlides);
} else {
    observeSlides();
}

if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    )
) {
    // true for mobile device

    jQuery(window).scroll(function () {
        if (jQuery(window).scrollTop() >= 780) {
            jQuery(
                "#product-section-single-tube.product-section-rb-starterkitprov2 .buy_buttons-wrap .product-form .product-form__submit"
            ).attr(
                "style",
                "position:fixed;bottom:15px;left:15px;width:100%;max-width:calc(100% - 30px) !important;margin-bottom:0;"
            );
        } else {
            jQuery(
                "#product-section-single-tube.product-section-rb-starterkitprov2 .buy_buttons-wrap .product-form .product-form__submit"
            ).attr("style", "position:relative;");
        }
    });

    // jQuery(window).on("scroll resize touchmove", function () {
    //   var $button = jQuery(
    //     "#product-section-single-tube.product-section-rb-starterkitprov2 .buy_buttons-wrap .product-form .product-form__submit"
    //   );

    //   // Get the current bounding rectangle of the button.
    //   var rect = $button[0].getBoundingClientRect();

    //   // Log the vertical positions to the console.
    //   console.log("Button Top:", rect.top, "Button Bottom:", rect.bottom);
    //   // true for mobile device
    //   if (rect.top <= 0) {
    //     jQuery(
    //       "#product-section-single-tube.product-section-rb-starterkitprov2 .buy_buttons-wrap .product-form .product-form__submit"
    //     ).attr(
    //       "style",
    //       "position:fixed;bottom:15px;left:15px;width:100%;max-width:calc(100% - 30px) !important;"
    //     );
    //   } else {
    //     jQuery(
    //       "#product-section-single-tube.product-section-rb-starterkitprov2 .buy_buttons-wrap .product-form .product-form__submit"
    //     ).attr("style", "position:relative;");
    //   }
    // });
}

function enhanceDropdowns() {
  const dropdowns = document.querySelectorAll('.rc-selling-plans__dropdown:not([data-trim-handled])');

  dropdowns.forEach((select) => {
    const originalTexts = Array.from(select.options).map(opt => opt.text);
    select.dataset.originalTexts = JSON.stringify(originalTexts);
    select.dataset.trimHandled = "true"; // prevent re-applying

    function updateSelectedLabel() {
      const selectedIndex = select.selectedIndex;
      const trimmedText = originalTexts[selectedIndex].replace(/^Delivery\s+/i, '');
      select.options[selectedIndex].text = trimmedText;
    }

    select.addEventListener('mousedown', () => {
      const originals = JSON.parse(select.dataset.originalTexts);
      Array.from(select.options).forEach((opt, i) => {
        opt.text = originals[i];
      });
    });

    select.addEventListener('change', updateSelectedLabel);

    // ✅ Fix: trim again even if no change
    select.addEventListener('focusout', () => {
      setTimeout(updateSelectedLabel, 10);
    });

    updateSelectedLabel(); // initial run
  });
}

// Safe unique name for MutationObserver
const deliveryTrimObserver = new MutationObserver(() => {
  if (document.querySelector('.rc-selling-plans__dropdown')) {
    enhanceDropdowns();
  }
});

deliveryTrimObserver.observe(document.body, {
  childList: true,
  subtree: true
});



